import { HttpClient } from '@angular/common/http';
import { CompanyInformation } from 'app/shared-html-components/details/models.js';
import { Observable, Subject } from 'rxjs';
import * as pdfMake from 'pdfmake/build/pdfmake.js';
import * as api from '../../shared/api/apihandler';
import * as pdfFonts from '../../../assets/js/vfs_fonts.js';
import { CalculationAssistant } from "app/shared/utilities/calculationAssist";
import { SharedDataService } from '../../shared/services/shared-data.service';
import { TaskData } from 'app/task-items/tasksData';
import { ActionApi } from 'app/shared/api/actionApi';
import { RRule } from 'rrule';
import { TranslateService } from '@ngx-translate/core';
import { RRULETRANSLATE } from '../recurrance-calculator/danishRecurrance';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

export class TaskListPDFCreator {
  private companyInfo: CompanyInformation;
  service: boolean = true;
  private taskList: Array<TaskData>;
  private property: any;

  private create = new BuildPDFMake(this.translate);
  fonts = {
    Arial: {
      normal: 'Arial-Regular.ttf',
      bold: 'Arial-Bold.ttf',
      italics: 'Arial-Italics.ttf',
      bolditalics: 'Arial-BoldItalics.ttf',
    },
    Roboto: {
      normal: 'Roboto-Regular.ttf',
      bold: 'Roboto-Medium.ttf',
      italics: 'Roboto-Italic.ttf',
      bolditalics: 'Roboto-MediumItalic.ttf',
    },
    Times: {
      normal: 'Times-Regular.ttf',
      bold: 'Times-Bold.ttf',
      italics: 'Times-Italic.ttf',
      bolditalics: 'Times-BoldItalic.ttf',
    },
    Ubuntu: {
      normal: 'Ubuntu-Regular.ttf',
      bold: 'Ubuntu-Bold.ttf',
      italics: 'Ubuntu-Italic.ttf',
      bolditalics: 'Ubuntu-BoldItalic.ttf',
    },
  };
  pdf = new Subject();
  taskApi = new ActionApi(this.http);

  constructor(private http: HttpClient, private sharedData: SharedDataService, private translate: TranslateService) { }

  async createPDF(propertyId) {
    try {
      await Promise.all([
        this.sharedData.companyInformation().subscribe({ next: (data) => this.companyInfo = data }),
        this.getTasks(propertyId)
      ]);
      this.buildPdf(this.companyInfo, this.taskList, this.property);
    } catch (error) {
      console.error(error);
    }
  }

  async getTasks(propertyId: string) {
    try {
      this.taskList = await this.taskApi.getActivitiesOnProperty(propertyId, 100).toPromise();
    } catch (error) {
      console.error(error);
      throw error; // Throw the error to stop Promise.all()
    }
  }

  async buildPdf(companyInfo: CompanyInformation, taskList, property) {
    let document = await this.create.getDocument(companyInfo, taskList, property);
    let pdf = await pdfMake.createPdf(document, null, this.fonts);
    this.pdf.next(pdf);
  }

}

class BuildPDFMake {
  calc = new CalculationAssistant();
  cardStyle = {
    paddingLeft: function () { return 10; },
    paddingRight: function () { return 10; },
    paddingTop: function () { return 8; },
    paddingBottom: function () { return 8; },
  };

  constructor(private translate: TranslateService) { }

  async getDocument(companyInfo: CompanyInformation, taskList, property) {
    let content = await this.content(companyInfo, taskList, property);
    let images = await this.images(companyInfo, property);
    return {
      header: this.header(),
      content: content,
      footer: this.footer(),
      images: images,
      pageMargins: this.pageMargins(),
      defaultStyle: this.defaultStyle(),
    };
  }

  async content(companyInfo: CompanyInformation, taskList, property) {
    let output = [
      await this.frontPage(companyInfo, property),
      await this.caseTaskTable(taskList, companyInfo)
    ];
    return output;
  }

  caseTaskTable(taskList, companyInfo: CompanyInformation) {
    let table = [];
    let body = [];

    body.push([
      {
        text: 'Generel arbejdsbeskrivelse',
        bold: true,
        fontSize: 12,
        margin: [0, 2]
      },
      {
        text: 'Udfaldskrav',
        bold: true,
        fontSize: 10,
        margin: [0, 2]
      }
    ]);

    table.push({
      table: {
        body,
        widths: [400, 100],
        headerRows: 1,
        dontBreakRows: true
      }
    });

    if (!!taskList) {
      for (let t of taskList) {
        console.log(t);
        let rec = '';
        if (!!t.recurrance) {
          let recurrance: RRule = RRule.fromString(t.recurrance);
          rec = RRULETRANSLATE.rruleTranslation(recurrance.toText(), companyInfo.companyLanguage);
        }
        
        let body = [];

        body.push([
          { text: t.subject + '\n' + t.description },
          { text: rec }
        ]);

        table.push({
          table: {
            dontBreakRows: true,
            body,
            widths: [400, 100],
          },
        });
      }
    }

    let output = {
      stack: [
        table
      ]
    };
    //console.log(output);
    return output;
  }

  rRuleToText(ruleString: string) {
    if (!!ruleString) {
      let rr = RRule.fromString(ruleString);
      let splittedTxt = rr.toText().toString().split(' ');
      let outPut = '';
      splittedTxt.forEach(x => {
        if (!isNaN(Number(x))) {
          x = x + '.';
        }
        switch (x) {
          case 'Monday':
          case 'Tuesday':
          case 'Wednesday':
          case 'Thursday':
          case 'Friday':
          case 'Saturday':
          case 'Sunday':
            outPut = outPut + this.translate.instant(x).toLowerCase();
            if (localStorage.getItem('language') == 'da-DK') {
              outPut = outPut + 'en ';
            } else {
              outPut = outPut + ' ';
            }
            break;
          default:
            outPut = outPut + this.translate.instant(x.toLowerCase()) + ' ';
            break;
        }
      });
      return outPut.charAt(0).toUpperCase() + outPut.slice(1);
    } else {
      return '';
    }
  }

  frontPage(companyInfo, property) {
    let originalDate = new Date();
    let formattedDate = originalDate.toLocaleString('da-DK', { year: 'numeric', month: 'long' });
    formattedDate = formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1);
    let companyAddress = companyInfo.address.split(',')[0].trim();
    let companyZipCodeCity = companyInfo.address.split(',')[1].trim();
    let propertyAddressLine1 = property.address.trim();
    let propertyAddressLine2 = property.zipCode.trim() + ' ' + property.city.trim();
    let add = propertyAddressLine1 + '\n' + propertyAddressLine2
    let image = {};
    let web;
    if (!!property.image) {
      image = {
        image: 'propertyImage',
        fit: [450, 350],
        alignment: 'center'
      }
    } else {
      image = { text: '', margin: [0, 160] }
    }
    if (!!companyInfo.website) {
      web = {
        columns: [
          { text: 'Web:', width: 30 },
          { text: companyInfo.website, link: companyInfo.website, width: 'auto' }
        ]
      }
    }
    let background1 = '#1f539f';
    let background2 = '#1f539f';
    if (companyInfo.id == '2605daad-d63b-4ccb-9c35-bce53c4becd4') {
      background1 = '#0b1d40';
      background2 = '#112e5d';
    }
    return {
      stack: [
        image,
        {
          table: {
            body: [
              [{ text: 'YDELSESBESKRIVELSE', alignment: 'center', fillColor: background1, color: 'white', fontSize: 18, bold: true, margin: [0, 30] }],
              [{ text: 'EJENDOM\n' + add, alignment: 'center', color: 'black', fontSize: 18, bold: true, margin: [0, 40, 0, 0] }],
              [{ text: formattedDate, alignment: 'center', color: '#7d7d7d', fontSize: 16, margin: [0, 20, 0, 60] }],
              [{
                columns: [
                  {
                    width: '*',
                    stack: [
                      { text: companyInfo.name, bold: true },
                      companyAddress,
                      companyZipCodeCity,
                      {
                        columns: [
                          { text: 'Tlf:', width: 30 },
                          { text: companyInfo.phone, width: 'auto' }
                        ]
                      },
                      {
                        columns: [
                          { text: 'Cvr:', width: 30 },
                          { text: companyInfo.vat, width: 'auto' }
                        ]
                      },
                      web
                    ],
                    color: 'white',
                    fontSize: 10,
                    margin: [40, 10, 0, 0]
                  },
                  {
                    width: '*',
                    stack: [
                      {
                        image: 'logo',
                        width: 150
                      }
                    ],
                    alignment: 'right',
                    margin: [0, 40, 40, 0]
                  }
                ],
                margin: [0, 10],
                fillColor: background2
              }],
            ],
            widths: ['*'],
            heights: [80, 80, 80, 140]
          },
          layout: 'noBorders',
          margin: [-40, 1, -40, 0]
        }
      ],
      pageBreak: 'after',
      absolutePosition: { x: 40, y: 40 }
    };
  }

  header() {
    return function (currentPage) {
      if (currentPage != 1) {
        return {
          text: [
            {
              text: 'Side ' + currentPage + ' | YDELSESBESKRIVELSE',
              fontSize: 10,
              color: '#7d7d7d'
            }
          ],
          columnGap: 0,
          margin: [40, 20, 40, 10],
        };
      } else {
        return '';
      }
    }
  }

  footer() {
    return function (currentPage, pageCount) {
      if (currentPage != 1) {
        return {
          width: 100,
          image: 'logo',
          margin: [0, 0, 20, 0],
          alignment: 'right'
        };
      } else {
        return '';
      }
    }
  }

  async images(companyInfo, property) {
    let path = 'https://jubloapi.azure-api.net/api/shared/attachments/';
    let after = '?userId=' + localStorage.getItem('bearer');
    let img = !!property.image ? (path + property.image + after) : null;
    let imgData = {};
    if (!!img) {
      imgData = {
        logo: path + companyInfo.logo,
        propertyImage: img
      };
    } else {
      imgData = {
        logo: path + companyInfo.logo
      };
    }
    return imgData;
  }

  pageMargins() {
    return [40, 60, 40, 40];
  }

  defaultStyle() {
    return {
      fontSize: 10,
      lineHeight: 1.2
    };
  }
}

interface RecurrenceRule {
  freq: string;
  interval: number;
  wkst: string;
}